
































import {Component, Prop, Vue} from 'vue-property-decorator';
import { Store } from 'vuex';
import {dispatchUpdateContact} from '@/store/contacts/actions';
import {IContact} from '@/interfaces';

@Component
export default class ContactNoteModal extends Vue {
  @Prop({default: null}) public contact!: IContact;
  public noteContactVisible = false;

  public async submit() {
    const formData = new FormData();
    // @ts-ignore
    const elements = this.$refs.noteContactForm.elements;
    for (const [key, item] of Object.entries(elements)) {
      // @ts-ignore
      if (item.name !== undefined) {
        // @ts-ignore
        formData.append(item.name, item.value ? item.value : '');
      }
    }
    if (this.contact) {
      await dispatchUpdateContact(
        this.$store,
        {
          contactId: this.contact.id,
          data: formData,
        },
      );
      this.noteContactVisible = false;
    }
  }

}
